import { Box, Button, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import EditUserIcon from "@assets/icons/editUserIcon";
import AddUserIcon from "@assets/icons/addUserIcon";
import { useNavigate } from "react-router";
import { validateFormField } from "@common/helpers";
import UserBasicInformation from "../../User/components/AddUser/userBasicInformation";
import UserOrganizationAddress from "./userOrganizationAddress";
import ContactInformation from "./contactInformation";
import { useDispatch, useSelector } from "react-redux";
import { getUserById, updateUser } from "@store/addUserSlice";
import { AppDispatch } from "@store/store";
interface UpdateUserProfileProps{
  setShowLoader: React.Dispatch<React.SetStateAction<boolean>>,
  showLoader:boolean,
}
const UpdateUserProfile: React.FC<UpdateUserProfileProps> = ({setShowLoader, showLoader}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector((state: any) => state.user);
  const [updateUserInfo, setUpdateUserInfo] = useState(false);
  const { userDetails, userDataLoading, updateUserloading } = useSelector(
    (state: any) => state.addUser
  );
  const [userData, setUserData] = React.useState({
    firstName: "",
    lastName: "",
    contactNumber: "",
  });

  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    contactNumber: "",
  });

  useEffect(() => {
    dispatch(getUserById({ userId: user.userId }));
  }, []);

  useEffect(() => {
    if (userDetails) {
      const mapUserDetail = {
        firstName: userDetails?.firstName || "",
        lastName: userDetails?.lastName || "",
        contactNumber: userDetails?.contactNumber || "",
      };
      setUserData((prev) => ({ ...prev, ...mapUserDetail }));
    }
  }, [userDetails]);

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | { value: string; name: string }>
  ) => {
    const { name, value } = event.target;
    validateFormField(name, value, setErrors);
    setUserData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateOnSubmit = () => {
    let tempErrors: any = { ...errors };
    let isValid = true;
    Object.entries(userData).forEach(([key, value]) => {
      if (!value && key !== "userStatus" && key !== "deactivationReson") {
        tempErrors[key] = "Mandatory field";
        isValid = false;
      }
    });
    Object.entries(errors).forEach(([key, value]) => {
      if (value) {
        isValid = false;
      }
    });
    setErrors((prev) => ({ ...prev, ...tempErrors }));
    return isValid;
  };

  const handleSubmit = () => {
    if (validateOnSubmit()) {
      const payload = {
        hospitalId: user?.hospitalId,
        securityGroupId: user?.securityGroupId,
        firstName: userData?.firstName.trim(),
        lastName: userData?.lastName.trim(),
        emailID: user?.emailID,
        countryCode: user?.countryCode,
        contactNumber: userData?.contactNumber,
        userTypeId: 2,
        userId: user?.userId,
        isActive: user?.isActive,
        zendeskSupportGroupId: user?.zendeskSupportGroupId,
        zendeskSupportGroup: user?.zendeskSupportGroup,
        zendeskUserId: user?.zendeskUserId,
        zendeskOrgId: user?.zendeskOrgId,
        isOnCallStatus: false,
        statusChangeReason: user?.statusChangeReason,
        statusChangeComment: user?.statusChangeComment,
      };
      dispatch(updateUser(payload));
      setShowLoader(true);
    }
  };

  return (
    <>
      {userDataLoading ? (
        <Box
          sx={{
            height: "calc(100vh - 191px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#fff",
          }}
        >
          <CircularProgress size="20px" />
        </Box>
      ) : (
        <Box
          className="md:shadow-md"
          sx={{
            height: "calc(100vh - 191px)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            overflow: "auto",
            backgroundColor: { xs: "#F1F5F7", sm: "#fff" },
          }}
        >
          <Box>
            <Box
              component="div"
              className="pt-2 px-2 bg-[#fff] hidden md:block"
            >
              <Box className="flex flex-row justify-between items-center border-dotted border-b-2 md:border-[#0000004D] border-[#666666]">
                <Box className="flex flex-row items-center">
                  <Typography className="md:px-2 py-3 px-1">
                    <AddUserIcon />
                  </Typography>
                  <Typography className="pt-1 flex items-center !font-semibold">
                    User Information
                  </Typography>
                </Box>
                <Typography
                  onClick={() => setUpdateUserInfo(true)}
                  className="cursor-pointer"
                >
                  <EditUserIcon />
                </Typography>
              </Box>
            </Box>
            <UserBasicInformation
              errors={errors}
              handleChange={handleChange}
              userData={userData}
              updateUserInfo={updateUserInfo}
              editUserDetails={true}
              setUpdateUserInfo={setUpdateUserInfo}
            />
            <UserOrganizationAddress
              handleChange={handleChange}
              updateUserInfo={updateUserInfo}
            />
            <ContactInformation
              errors={errors}
              handleChange={handleChange}
              updateUserInfo={updateUserInfo}
              userData={userData}
            />
          </Box>

          <Box className="w-full mt-4 bg-white mt-4 md:flex flex-row-reverse justify-between md:border-dotted md:border-t-2 md:border-[#0000004D] md:border-[#666666]">
            <Box className="p-4 flex gap-4 md:w-[50%] lg:w-[35%]">
              <Button
                sx={{
                  backgroundColor: "#fff",
                  color: "#318FE0",
                  textTransform: "none",
                  padding: "10px 18px",
                  fontSize: "1rem",
                  width: "100%",
                  border: "1px solid #318FE0",
                }}
                onClick={() => navigate("/?status=active")}
              >
                Back
              </Button>
              <Button
                sx={{
                  backgroundColor: !updateUserInfo ? "#A1A3A6" : "#318FE0",
                  color: "#ffffff !important",
                  textTransform: "none",
                  padding: "10px 18px",
                  fontSize: "1rem",
                  width: "100%",
                }}
                disabled={!updateUserInfo}
                onClick={handleSubmit}
              >
                <Typography className="!flex !gap-2 !items-center">
                 {(showLoader && updateUserloading) &&  <CircularProgress style={{'color': 'white'}} size="20px"/>} Update
                 </Typography>
              </Button>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default UpdateUserProfile;
